import {Component, OnInit} from '@angular/core';
import {NavService} from '../../services/nav.service';

@Component({
    selector: 'app-core',
    templateUrl: './core.component.html',
    styleUrls: ['./core.component.less'],
})
export class CoreComponent implements OnInit {

    constructor(private navService: NavService) {
    }

    hamburgerItems = [];

    ngOnInit() {
        this.hamburgerItems = this.navService.getRootNavItemsFiltered(true);
    }
}
